import { ExecuteRequest, ExternalScriptExecuteResult } from "../../../../domain/localhost/items";
import { Patient } from "../../../../domain/patient";

export class CommunicatorBase {
  constructor(protected _request: ExecuteRequest, protected _registerResult: (result: ExternalScriptExecuteResult) =>  Promise<void>, protected _getConfiguration: (key: string) => Promise<any>) {
  }
  onError: () => void = () => {};
  onComplete: () => void = () => {};
  getPatient: (patientCode: string) => Promise<Patient> = () => null;
  postMessage: (message: any) => void = () => {};
}
